import React, { isValidElement, ReactNode, FC, } from "react";
import classNames from "classnames";
import { ScanPageContentProps, ScanPageBodyItemEnum, ScanPageContentItemEnum, } from "../../interface";

const Content: FC<ScanPageContentProps> = props => {
  const { children, className, style, } = props;
  // const renderChildren = (childrenNodes: ReactNode): ReactNode => {
  //   return React.Children.map(childrenNodes, child => {
  //     const childElement = child as React.FunctionComponentElement<ScanPageContentProps>;
  //     if (!isValidElement(childElement)) return null;
  //     if (!childElement.type) return null;
  //     const { displayName } = childElement.type;
  //     if (displayName && displayName in ScanPageContentItemEnum) {
  //       return React.cloneElement(childElement);
  //     } else {
  //       console.error(
  //         'Warning: ScanPageContent has a child which is not a Count component',
  //       );
  //     }
  //   });
  // };
  const classes = classNames('scan-page-body-content', className);
  return (
    <div className={classes} style={style}>{children}</div>
  );
};

Content.displayName = ScanPageBodyItemEnum.Content;

export default Content;